"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.popoverBodyInjectionKey = void 0;
const create_injection_key_1 = require("../../_utils/vue/create-injection-key");
exports.popoverBodyInjectionKey = (0, create_injection_key_1.createInjectionKey)('n-popover-body');
